import { _t } from './components/base.js'

export const headerLayout = 2
export const mobileLayout = 1
export const forgotPasswordVersion = 1

export const contactConfig = {
    phoneNumber: _t('contact.phoneNumber'),
    openingHours: _t('contact.openingHours'),
}

$('body').addClass(`header-layout-${headerLayout}`)
$('body').addClass(`able-mobile-layout-${mobileLayout}`)
